<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:01:34
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-30 12:00:22
-->
<template>
  <!-- 新建商品组弹框 -->
  <span>
    <el-button type="primary" @click="dialogCreatedVisible = true"
      >新建商品组</el-button
    >
    <el-dialog
      title="新建商品组"
      width="25%"
      :visible.sync="dialogCreatedVisible"
      destroy-on-close
      :before-close="clear"
    >
      <el-form
        :model="createdFrom"
        ref="joinFrom"
        :rules="createdFromRules"
        hide-required-asterisk
      >
        <el-form-item label="商品组名称" label-width="84px" prop="shopsName">
          <el-input
            v-model="createdFrom.shopsName"
            autocomplete="off"
            placeholder="请输入商品组名称"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear">取消</el-button>
        <el-button type="primary" @click="createConfirm">确认</el-button>
      </div>
    </el-dialog>
  </span>
</template>
<script>
import { createGroup } from "@/api/shopManage";
export default {
  name: "createDialog",
  data() {
    return {
      dialogCreatedVisible: false,
      createdFromRules: {
        shopsName: [{ required: true, message: "商品组名称不能为空" }],
      },
      createdFrom: {
        shopsName: "",
      },
    };
  },
  props: {
    platformId: {
      type: [Number, String],
      default: 1,
    },
  },
  methods: {
    createConfirm() {
      this.$refs.joinFrom.validate((valid) => {
        if (valid) {
          const createParams = {
            remark: "",
            group_name: this.createdFrom.shopsName,
            product_ids: "",
            platform_id: this.platformId,
          };
          this.createGroup(createParams);
        }
      });
    },
    async createGroup(val) {
      const { code } = await createGroup(val);
      if (code === 0) {
        this.$message.success("创建商品组成功");
        this.$emit("refresh");
        this.dialogCreatedVisible = false;
      }
    },
    clear() {
      this.createdFrom = {
        shopsName: "",
      };
      this.dialogCreatedVisible = false;
    },
  },
};
</script>